"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : CUSTOM RADIO : STYLES--------------- ++++++++++ */


var _default = {
  radio: {
    position: 'relative',
    cursor: 'pointer',
    lineHeight: (0, _index.pxToEm)(24),
    fontSize: (0, _index.pxToEm)(16),
    marginBottom: (0, _index.pxToEm)(5),
    display: 'flex',
    alignItems: 'center',
    color: function color(props) {
      return props.disabled ? 'rgba(6, 43, 117, 0.1)' : 'rgba(6, 43, 117, 0.50)';
    },
    '& .radiospan': {
      position: 'relative',
      display: 'block',
      // float: 'left',
      marginRight: (0, _index.pxToEm)(10),
      width: (0, _index.pxToEm)(30),
      height: (0, _index.pxToEm)(30),
      background: '#fafbfc',
      border: (0, _index.replacePXinStringWithEM)('2px solid #eef2f6'),
      borderRadius: '100%',
      '&:after': {
        content: '""',
        position: 'absolute',
        top: (0, _index.pxToEm)(3),
        left: (0, _index.pxToEm)(3),
        width: (0, _index.pxToEm)(20),
        height: (0, _index.pxToEm)(20),
        borderRadius: '100%',
        background: '#1494f4',
        transform: 'scale(0)',
        transition: 'all 0.2s ease',
        opacity: 0.08,
        pointerEvents: 'none'
      }
    },
    '& .radio': {
      display: 'none'
    },
    '& .radio:checked + .radiospan': {
      borderColor: '#1494f4',
      '&:after': {
        transform: 'scale(1)',
        transition: 'all 0.2s cubic-bezier(0.35, 0.9, 0.4, 0.9)',
        opacity: 1
      }
    },
    '& .radio:disabled + .radiospan': {
      pointerEvents: 'none',
      opacity: 0.5
    },
    extend: (0, _index.themeStyleHelper)(_index.theme, 'color', function (theme, uniqueColor) {
      return {
        '& .radiospan:after': {
          background: theme.color[uniqueColor].medium.swatch
        },
        '& .radio:checked + .radiospan': {
          borderColor: theme.color[uniqueColor].medium.swatch
        }
      };
    })
  }
};
exports.default = _default;